import React from 'react';

import { TagPolicySubForm } from '@vlabs/pages/handlers/forms';
import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import st from './shared.module.sass';

function StepTagPolicy() {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('handlers:add_tag_question')}
        </StepTitle>
      )}
    >
      <TagPolicySubForm />
    </Step>
  );
}

StepTagPolicy.fieldNames = [
  'tagPolicy',
];

export { StepTagPolicy };
